export enum OperatorAvailabilityStatus {
  AVAILABLE = "available",
  UNAVAILABLE = "unavailable",
  AVAILABLE_OUT_SECTOR = "available_out_sector",
  UNAVAILABLE_OUT_SECTOR = "unavailable_out_sector",
}

interface operatorAvailabilityValues {
  color: string;
  icon: string;
  name: OperatorAvailabilityStatus;
  label: string;
}

export const operatorAvailabilityValues: operatorAvailabilityValues[] = [
  {
    color: "rgba(17,191,164,0.3)",
    icon: "pi-check",
    name: OperatorAvailabilityStatus.AVAILABLE,
    label: "Disponible",
  },
  {
    color: "rgba(255,125,41,0.3)",
    icon: "pi-times",
    name: OperatorAvailabilityStatus.UNAVAILABLE,
    label: "Indisponible",
  },
  {
    color: "rgba(236,185,0,0.3)",
    icon: "pi-check",
    name: OperatorAvailabilityStatus.AVAILABLE_OUT_SECTOR,
    label: "Disponible hors secteur",
  },
  {
    color: "rgba(255,0,0,0.3)",
    icon: "pi-times",
    name: OperatorAvailabilityStatus.UNAVAILABLE_OUT_SECTOR,
    label: "Indisponible hors secteur",
  },
];

export const operatorAvailabilityValuesByStatus = (
  status?: OperatorAvailabilityStatus,
) => operatorAvailabilityValues.find((el) => el.name === status);
